import { createFileRoute } from '@tanstack/react-router';
import { assessmentComparisonSearchSchema } from '@/pages/assessment/lib/comparisonSearchSchema';
import { AssessmentComparisonPage } from '@/pages/assessment/ui/AssessmentComparisonPage';
import { routeValidateQuerySearch } from '@/shared/lib/route';

export const Route = createFileRoute('/_protected/assessment/$assessmentId/')({
  component: AssessmentComparisonPage,
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: false,
      customSchema: assessmentComparisonSearchSchema,
      defaultValues: undefined,
    }),
});
